export default {
  // Home page
  home: {
    title: 'timer.today - 专业在线计时器、秒表和世界时钟工具',
    description: '免费在线计时工具，包括倒计时器、精密秒表和世界时钟。适用于工作效率、烹饪、学习、运动训练和时区管理。无需下载，即开即用。',
    keywords: ['在线计时器', '倒计时器', '网页秒表', '世界时钟', '工作效率计时器', '番茄工作法', '烹饪计时器', '免费计时工具', '浏览器计时器', '时间管理'],
    ogTitle: '专业在线计时工具 - timer.today',
    ogDescription: '专业在线计时工具平台，提供倒计时器、秒表和世界时钟功能',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "timer.today",
      "description": "专业在线计时工具平台，提供倒计时器、秒表和世界时钟功能",
      "url": "https://timer.today",
      "applicationCategory": "Productivity",
      "operatingSystem": "Web Browser",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY"
      }
    }
  },

  // Timer page
  timer: {
    title: '在线计时器 - 免费倒计时器，适用于工作效率和时间管理',
    description: '免费在线倒计时器，支持自定义小时、分钟和秒数。适用于番茄工作法、烹饪、学习、工作休息和时间管理。具有声音提醒和桌面通知功能。',
    keywords: ['在线计时器', '倒计时器', '番茄计时器', '工作效率计时器', '工作计时器', '学习计时器', '烹饪计时器', '休息计时器', '时间管理', '专注计时器'],
    ogTitle: '在线倒计时器 - timer.today',
    ogDescription: '免费在线倒计时器，支持自定义时间设置，适用于工作效率和时间管理',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "在线计时器",
      "description": "免费在线倒计时器，支持自定义时间设置，适用于工作效率和时间管理",
      "applicationCategory": "Productivity"
    }
  },

  // Stopwatch page
  stopwatch: {
    title: '在线秒表 - 高精度计时器，适用于运动、训练和精确计时',
    description: '专业在线秒表，具有毫秒级精度。适用于运动训练、烹饪计时、健身锻炼、学习练习以及任何需要精确时间测量的活动。',
    keywords: ['在线秒表', '精密秒表', '运动计时器', '训练秒表', '毫秒计时器', '精确秒表', '健身计时器', '烹饪秒表', '免费秒表'],
    ogTitle: '在线秒表 - timer.today',
    ogDescription: '专业在线秒表，具有毫秒级精度，适用于运动训练和精确计时',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "在线秒表",
      "description": "专业在线秒表，具有毫秒级精度，适用于运动训练和精确计时",
      "applicationCategory": "Sports"
    }
  },

  // World Clock page
  worldclock: {
    title: '世界时钟 - 全球时区和国际时间显示',
    description: '实时世界时钟，显示全球主要城市的当前时间。同时查看多个时区，自动更新。适用于国际商务、旅行规划和全球沟通。',
    keywords: ['世界时钟', '时区', '国际时间', '全球时间', '城市时间', '时区转换器', '世界时间', '国际时钟', '商务时区'],
    ogTitle: '世界时钟 - timer.today',
    ogDescription: '实时世界时钟，显示全球主要城市的当前时间，自动更新时区信息',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "世界时钟",
      "description": "实时世界时钟，显示全球主要城市的当前时间，自动更新时区信息",
      "applicationCategory": "Reference"
    }
  },

  // Not Found page
  notfound: {
    title: '页面未找到 - timer.today',
    description: '抱歉，您访问的页面不存在。请返回首页使用我们的在线计时器、秒表和世界时钟工具。',
    keywords: ['404', '页面未找到', '计时工具'],
    ogTitle: '页面未找到 - timer.today',
    ogDescription: '您访问的页面不存在'
  },

  // Terms page
  terms: {
    title: '服务条款 - timer.today',
    description: 'timer.today在线计时工具平台的服务条款和使用协议。了解我们的服务规则、用户权利和责任。',
    keywords: ['服务条款', '用户协议', '计时工具条款'],
    ogTitle: '服务条款 - timer.today',
    ogDescription: 'timer.today在线计时工具平台的服务条款和使用协议',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "服务条款",
      "description": "timer.today在线计时工具平台的服务条款和使用协议"
    }
  },

  // Dynamic timer pages
  timerMinutes: (minutesNum: number) => {
    const useCases = {
      1: '护眼休息、快速冥想、茶叶冲泡',
      3: '煮鸡蛋、冲咖啡、短暂休息',
      5: '冥想练习、溏心蛋制作、快速锻炼',
      10: '阅读学习、电话会议、学习休息',
      15: '番茄工作法、中等强度锻炼、深度学习',
      20: '专注工作时段、健身锻炼、技能训练',
      25: '标准番茄工作法、深度工作、专业学习',
      30: '长时间专注工作、健身锻炼、深度学习',
      45: '深度工作时段、演讲练习、专业训练',
      60: '工作时间块、课程学习、长时间锻炼'
    }[minutesNum] || '工作效率和时间管理';

    return {
      title: `${minutesNum}分钟计时器 - 在线倒计时器，提升工作效率`,
      description: `免费${minutesNum}分钟倒计时器，适用于${useCases}。具有声音提醒、全屏模式和自定义设置。立即开始您的${minutesNum}分钟计时！`,
      keywords: [`${minutesNum}分钟计时器`, `${minutesNum}分钟倒计时`, '倒计时器', '工作效率计时器', useCases.split('、')[0], useCases.split('、')[1]],
      ogTitle: `${minutesNum}分钟计时器 - timer.today`,
      ogDescription: `${minutesNum}分钟倒计时器，具有声音提醒和桌面通知功能，适用于${useCases}`,
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": `${minutesNum}分钟计时器`,
        "description": `${minutesNum}分钟倒计时器，具有声音提醒和桌面通知功能，适用于${useCases}`,
        "applicationCategory": "Productivity"
      }
    };
  },

  // Dynamic city pages
  city: ({ cityName, countryName, timezone }: { cityName: string, countryName: string, timezone: string }) => ({
    title: `${cityName}时间 - ${cityName}当前时间和时区查询`,
    description: `🌍 ${cityName}现在几点？查看${countryName}${cityName}的当前本地时间、时区（${timezone}）、UTC时差和日期。适合安排国际会议和跨国通话。实时更新！`,
    keywords: [
      `${cityName}时间`,
      `${cityName}当前时间`,
      `${cityName}现在几点`,
      `${cityName}时区`,
      `${cityName}本地时间`,
      `${countryName}${cityName}时间`,
      `${cityName}时钟`,
      '世界时钟',
      '国际时间',
      '时区查询'
    ],
    ogTitle: `${cityName}当前时间 - ${countryName} - 实时时钟`,
    ogDescription: `查看${cityName}当前时间（${timezone}）。实时更新时区信息和日期。适合国际日程安排。`,
    ogUrl: `https://timer.today/worldclock/time-in-${cityName.toLowerCase().replace(/\s+/g, '-')}`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": `${cityName}当前时间`,
      "description": `${countryName}${cityName}的当前本地时间，时区：${timezone}`,
      "url": `https://timer.today/worldclock/time-in-${cityName.toLowerCase().replace(/\s+/g, '-')}`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "Timer.Today",
        "url": "https://timer.today"
      },
      "about": {
        "@type": "Place",
        "name": cityName,
        "address": {
          "@type": "PostalAddress",
          "addressCountry": countryName
        }
      },
      "mainEntity": {
        "@type": "ClockInfo",
        "name": `${cityName}时间`,
        "timezone": timezone
      }
    }
  }),

  // Timestamp converter page
  timestamp: {
    title: 'Unix时间戳转换器 - 纪元时间转日期 & 代码示例 | timer.today',
    description: '免费在线Unix时间戳转换工具。纪元时间与日期互转，包含Python、Java、MySQL、JavaScript、PHP的时间戳代码速查表。',
    keywords: [
      '时间戳转换',
      'unix时间戳',
      '时间戳转换器',
      '时间戳转日期',
      '日期转时间戳',
      'unix时间转换',
      'python时间戳',
      'java时间戳',
      'mysql时间戳',
      'javascript时间戳',
      'php时间戳',
      'iso 8601',
      '当前纪元时间',
      '时间戳速查表'
    ],
    ogTitle: 'Unix时间戳转换器 & 纪元时间工具',
    ogDescription: '纪元时间转日期，包含Python、Java、MySQL、JavaScript、PHP代码示例。免费在线时间戳转换器。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Unix时间戳转换器",
      "description": "免费在线Unix时间戳转换器，包含Python、Java、MySQL、JavaScript、PHP代码示例",
      "url": "https://timer.today/timestamp",
      "applicationCategory": "DeveloperApplication",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY"
      },
      "featureList": [
        "Unix时间戳转日期",
        "日期转时间戳",
        "当前纪元时间显示",
        "Python、Java、MySQL、JavaScript、PHP代码示例",
        "支持秒级和毫秒级格式",
        "ISO 8601格式输出"
      ]
    }
  },

  // MySQL时间戳页面
  mysqlTimestamp: {
    title: 'MySQL时间戳教程 - UNIX_TIMESTAMP与FROM_UNIXTIME指南 | timer.today',
    description: '📘 完整的MySQL时间戳指南。学习UNIX_TIMESTAMP()、FROM_UNIXTIME()、TIMESTAMP与DATETIME对比、时区处理和性能优化，含实战SQL示例。',
    keywords: [
      'mysql时间戳',
      'mysql unix_timestamp',
      'mysql from_unixtime',
      'mysql时间戳转日期',
      'mysql日期转时间戳',
      'mysql时间戳格式',
      'mysql timestamp datetime',
      'mysql时间戳时区',
      'mysql当前时间戳',
      'mysql时间戳函数',
      'mysql纪元时间'
    ],
    ogTitle: 'MySQL时间戳教程 - 完整指南含SQL示例',
    ogDescription: '掌握MySQL时间戳函数：UNIX_TIMESTAMP()、FROM_UNIXTIME()、时区处理和性能技巧。包含实战SQL示例。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TechArticle",
      "name": "MySQL时间戳完整指南",
      "description": "关于MySQL时间戳函数和最佳实践的综合教程",
      "url": "https://timer.today/mysql-timestamp",
      "author": {
        "@type": "Organization",
        "name": "Timer.Today"
      },
      "datePublished": "2024-01-04",
      "educationalLevel": "Intermediate",
      "proficiencyLevel": "Intermediate"
    }
  },

  // SQL时间戳页面（通用）
  sqlTimestamp: {
    title: 'SQL时间戳教程 - MySQL、PostgreSQL、Oracle、SQL Server完整指南 | timer.today',
    description: '📘 SQL时间戳完整教程，涵盖所有主流数据库。掌握MySQL UNIX_TIMESTAMP、PostgreSQL EXTRACT(EPOCH)、Oracle日期运算、SQL Server DATEDIFF_BIG，附带实用示例。',
    keywords: [
      'sql时间戳',
      'mysql时间戳',
      'postgresql时间戳',
      'oracle时间戳',
      'sql server时间戳',
      'sql unix时间戳',
      'sql时间戳转日期',
      'sql日期转时间戳',
      'sql当前时间戳',
      'sql时间戳函数',
      '时间戳sql',
      'sql时间戳格式',
      'sql时间戳比较',
      'sql epoch时间',
      '数据库时间戳'
    ],
    ogTitle: 'SQL时间戳教程 - 所有主流数据库完整指南',
    ogDescription: '掌握MySQL、PostgreSQL、Oracle和SQL Server的时间戳处理。综合指南包含语法对比和实用SQL示例。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TechArticle",
      "name": "SQL时间戳所有数据库完整指南",
      "description": "MySQL、PostgreSQL、Oracle和SQL Server时间戳函数综合教程",
      "url": "https://timer.today/sql-timestamp",
      "author": {
        "@type": "Organization",
        "name": "Timer.Today"
      },
      "datePublished": "2025-01-05",
      "dateModified": "2025-01-05",
      "educationalLevel": "中级",
      "proficiencyLevel": "中级",
      "keywords": "SQL, MySQL, PostgreSQL, Oracle, SQL Server, 时间戳, 数据库"
    }
  },

  // Python时间戳页面
  pythonTimestamp: {
    title: 'Python时间戳教程 - datetime、time、calendar模块指南 | timer.today',
    description: '🐍 完整的Python时间戳指南。掌握datetime、time和calendar模块。学习时区处理、时间戳转换和实用代码示例。',
    keywords: [
      'python时间戳',
      'python获取时间戳',
      'python datetime timestamp',
      'python时间戳转datetime',
      'python datetime转时间戳',
      'python time timestamp',
      'python时间戳转日期',
      'python unix时间戳',
      'python时间戳时区',
      'python时间戳毫秒'
    ],
    ogTitle: 'Python时间戳教程 - datetime与time模块指南',
    ogDescription: '掌握Python的datetime、time和calendar模块处理时间戳。包含时区处理和实用示例。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TechArticle",
      "name": "Python时间戳完整指南",
      "description": "关于Python datetime和time模块处理时间戳的综合教程",
      "url": "https://timer.today/python-timestamp",
      "programmingLanguage": "Python"
    }
  },

  // JavaScript时间戳页面
  javascriptTimestamp: {
    title: 'JavaScript时间戳教程 - Date对象和方法指南 | timer.today',
    description: '⚡ 完整的JavaScript时间戳指南。掌握Date对象、Date.now()、getTime()、时间戳转换和Day.js等流行库。',
    keywords: [
      'javascript时间戳',
      'js时间戳',
      'javascript获取时间戳',
      'javascript date timestamp',
      'date.now javascript',
      'javascript时间戳转日期',
      'javascript日期转时间戳',
      'javascript unix时间戳',
      'javascript时间戳毫秒',
      'javascript date gettime'
    ],
    ogTitle: 'JavaScript时间戳教程 - Date对象指南',
    ogDescription: '掌握JavaScript Date对象和时间戳方法。包含现代库和实用示例。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TechArticle",
      "name": "JavaScript时间戳完整指南",
      "description": "关于JavaScript Date对象和时间戳处理的综合教程",
      "url": "https://timer.today/javascript-timestamp",
      "programmingLanguage": "JavaScript"
    }
  },

  // YouTube时间戳链接生成器
  youtubeLink: {
    title: 'YouTube时间戳链接生成器 - 创建可分享的视频链接 | timer.today',
    description: '📺 生成从特定时间开始的YouTube链接。完美用于在社交媒体、邮件和论坛分享视频片段。适用于所有YouTube视频！',
    keywords: [
      'youtube时间戳链接',
      'youtube时间戳',
      'youtube带时间戳链接',
      'youtube特定时间链接',
      'youtube分享时间戳',
      'youtube时间戳网址',
      'youtube开始时间链接',
      'youtube视频时间戳',
      'youtube时间戳生成器',
      'youtube链接生成器',
      'youtube嵌入时间戳'
    ],
    ogTitle: 'YouTube时间戳链接生成器 - 在精确时刻分享视频',
    ogDescription: '创建从任何时间开始的YouTube链接。为社交媒体、邮件和嵌入代码生成带时间戳的可分享URL。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "YouTube时间戳链接生成器",
      "description": "生成带时间戳的YouTube链接，用于分享视频的特定片段",
      "url": "https://timer.today/youtube-timestamp-link",
      "applicationCategory": "UtilitiesApplication",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY"
      },
      "featureList": [
        "生成短链接和完整YouTube链接",
        "创建带时间戳的嵌入代码",
        "实时视频预览",
        "支持多种URL格式",
        "一键复制"
      ]
    }
  },

  // YouTube时间戳生成器（用于章节/评论）
  youtubeGenerator: {
    title: 'YouTube时间戳生成器 - 创建视频章节和评论时间戳 | timer.today',
    description: '🎬 为YouTube视频描述和评论生成时间戳。创建章节、转换秒数为时间戳格式，提升视频SEO。免费工具！',
    keywords: [
      'youtube时间戳生成器',
      'youtube时间戳',
      'youtube章节',
      'youtube视频章节',
      'youtube时间戳评论',
      'youtube时间戳格式',
      'youtube章节生成器',
      'youtube时间戳转换器',
      'youtube描述时间戳',
      'youtube视频时间戳',
      '如何添加youtube章节'
    ],
    ogTitle: 'YouTube时间戳生成器 - 创建章节和评论',
    ogDescription: '为YouTube视频描述和评论生成格式化的时间戳。创建章节以改善观看体验和SEO。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "YouTube时间戳生成器",
      "description": "为YouTube视频章节、描述和评论生成时间戳",
      "url": "https://timer.today/youtube-timestamp-generator",
      "applicationCategory": "UtilitiesApplication",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY"
      },
      "featureList": [
        "视频章节生成器",
        "秒数转时间戳转换器",
        "评论时间戳模板",
        "批量转换",
        "格式验证"
      ]
    }
  },

  // Discord时间戳生成器
  discordTimestamp: {
    title: 'Discord时间戳生成器 - 创建<t:format>动态时间代码 | timer.today',
    description: '🎮 生成Discord时间戳，自动时区转换。创建<t:时间戳:格式>代码用于活动、倒计时和公告。适用于所有Discord频道！',
    keywords: [
      'discord时间戳',
      'discord时间戳生成器',
      'discord时间格式',
      'discord时间戳代码',
      'discord <t> 格式',
      'discord时间戳转换器',
      'discord动态时间戳',
      'discord时间转换',
      'discord活动时间戳',
      'discord倒计时',
      'discord时区转换'
    ],
    ogTitle: 'Discord时间戳生成器 - 自动时区转换',
    ogDescription: '生成Discord时间戳代码，自动适应每个用户的本地时区。完美适用于活动、Raid和社区调度。',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Discord时间戳生成器",
      "description": "生成Discord时间戳代码，自动时区转换，适用于活动和公告",
      "url": "https://timer.today/discord-timestamp-generator",
      "applicationCategory": "UtilitiesApplication",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY"
      },
      "featureList": [
        "7种Discord时间戳格式",
        "自动时区转换",
        "实时预览",
        "一键复制",
        "格式参考表",
        "常见用例指南"
      ]
    }
  },

  // Dynamic country pages
  country: ({ countryName, citiesCount }: { countryName: string, citiesCount: number }) => ({
    title: `${countryName}时间 - ${countryName}当前时间和时区`,
    description: `🌍 查看${countryName}${citiesCount}多个城市的当前时间。实时时区更新、UTC时差和本地时间。适合商务会议和国际协调。`,
    keywords: [
      `${countryName}时间`,
      `${countryName}当前时间`,
      `${countryName}时区`,
      `${countryName}现在几点`,
      `${countryName}本地时间`,
      `${countryName}城市时间`,
      `${countryName}时钟`,
      '世界时钟',
      '国际时间'
    ],
    ogTitle: `${countryName}当前时间 - ${citiesCount}多个城市`,
    ogDescription: `查看${countryName}所有主要城市的当前时间。实时时区信息和实时更新。`,
    ogUrl: `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": `${countryName}时间`,
      "description": `${countryName}当前本地时间，覆盖${citiesCount}多个城市`,
      "url": `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "Timer.Today",
        "url": "https://timer.today"
      },
      "about": {
        "@type": "Place",
        "name": countryName,
        "geo": {
          "@type": "Country",
          "name": countryName
        }
      }
    }
  })
};